import { useState, useRef, useEffect, useMemo, useCallback, type CSSProperties } from 'react'
import { SearchIcon, ClockIcon } from '../icons'

const EMOJI_CATEGORIES = [
  {
    key: 'recentes', label: 'Recentes', icon: '\uD83D\uDD52', emojis: [],
  },
  {
    key: 'smileys', label: 'Smileys e pessoas', icon: '\uD83D\uDE00',
    emojis: [
      '\uD83D\uDE00','\uD83D\uDE03','\uD83D\uDE04','\uD83D\uDE01','\uD83D\uDE06','\uD83D\uDE05','\uD83E\uDD23','\uD83D\uDE02',
      '\uD83D\uDE42','\uD83D\uDE43','\uD83D\uDE09','\uD83D\uDE0A','\uD83D\uDE07','\uD83E\uDD70','\uD83D\uDE0D','\uD83E\uDD29',
      '\uD83D\uDE18','\uD83D\uDE17','\uD83D\uDE1A','\uD83D\uDE19','\uD83E\uDD72','\uD83D\uDE0B','\uD83D\uDE1B','\uD83D\uDE1C',
      '\uD83E\uDD2A','\uD83D\uDE1D','\uD83E\uDD11','\uD83E\uDD17','\uD83E\uDD2D','\uD83E\uDD2B','\uD83E\uDD14','\uD83E\uDD10',
      '\uD83D\uDE28','\uD83D\uDE11','\uD83D\uDE36','\uD83D\uDE0C','\uD83D\uDE0F','\uD83D\uDE12','\uD83D\uDE44','\uD83D\uDE2C',
      '\uD83E\uDD25','\uD83D\uDE0C','\uD83D\uDE14','\uD83D\uDE2A','\uD83E\uDD24','\uD83D\uDE34','\uD83D\uDE37','\uD83E\uDD12',
      '\uD83E\uDD15','\uD83E\uDD22','\uD83E\uDD2E','\uD83E\uDD27','\uD83E\uDD75','\uD83E\uDD76','\uD83E\uDD74','\uD83D\uDE35',
      '\uD83E\uDD2F','\uD83E\uDD20','\uD83E\uDD73','\uD83E\uDD78','\uD83D\uDE0E','\uD83E\uDD13','\uD83E\uDDD0','\uD83D\uDE15',
      '\uD83D\uDE1F','\uD83D\uDE41','\u2639\uFE0F','\uD83D\uDE2E','\uD83D\uDE2F','\uD83D\uDE32','\uD83D\uDE33','\uD83E\uDD7A',
      '\uD83E\uDD79','\uD83D\uDE26','\uD83D\uDE27','\uD83D\uDE28','\uD83D\uDE30','\uD83D\uDE25','\uD83D\uDE22','\uD83D\uDE2D',
      '\uD83D\uDE31','\uD83D\uDE16','\uD83D\uDE23','\uD83D\uDE1E','\uD83D\uDE13','\uD83D\uDE29','\uD83D\uDE38','\uD83D\uDE21',
      '\uD83D\uDE20','\uD83E\uDD2C','\uD83D\uDE08','\uD83D\uDC80','\u2620\uFE0F','\uD83D\uDCA9','\uD83E\uDD21','\uD83D\uDC79',
      '\uD83D\uDC7A','\uD83D\uDC7B','\uD83D\uDC7D','\uD83D\uDC7E','\uD83E\uDD16','\uD83C\uDF83','\uD83D\uDC4D','\uD83D\uDC4E',
      '\uD83D\uDC4C','\uD83E\uDD0C','\u270C\uFE0F','\uD83E\uDD1E','\uD83E\uDD1F','\uD83E\uDD18','\uD83D\uDC48','\uD83D\uDC49',
      '\uD83D\uDC46','\uD83D\uDD95','\uD83D\uDC47','\u261D\uFE0F','\uD83D\uDC4A','\u270A','\uD83E\uDD1B','\uD83E\uDD1C',
      '\uD83D\uDC4F','\uD83D\uDE4C','\uD83E\uDEF6','\uD83D\uDC50','\uD83E\uDD32','\uD83E\uDD1D','\uD83D\uDE4F','\uD83D\uDCAA',
      '\uD83D\uDC40','\uD83D\uDC41\uFE0F','\uD83D\uDC45','\uD83D\uDC44','\uD83D\uDC76','\uD83E\uDDD2','\uD83D\uDC66','\uD83D\uDC67',
      '\uD83E\uDDD1','\uD83D\uDC71','\uD83D\uDC68','\uD83D\uDC69','\uD83E\uDDD3','\uD83D\uDC74','\uD83D\uDC75',
    ],
  },
  {
    key: 'animais', label: 'Animais e natureza', icon: '\uD83D\uDC36',
    emojis: [
      '\uD83D\uDC36','\uD83D\uDC31','\uD83D\uDC2D','\uD83D\uDC39','\uD83D\uDC30','\uD83E\uDD8A','\uD83D\uDC3B','\uD83D\uDC3C',
      '\uD83D\uDC28','\uD83D\uDC2F','\uD83E\uDD81','\uD83D\uDC2E','\uD83D\uDC37','\uD83D\uDC3D','\uD83D\uDC38','\uD83D\uDC35',
      '\uD83D\uDE48','\uD83D\uDE49','\uD83D\uDE4A','\uD83D\uDC12','\uD83D\uDC14','\uD83D\uDC27','\uD83D\uDC26','\uD83D\uDC24',
      '\uD83E\uDD85','\uD83E\uDD89','\uD83E\uDD87','\uD83D\uDC3A','\uD83E\uDD84','\uD83D\uDC1C','\uD83D\uDC1B','\uD83E\uDEB0',
      '\uD83D\uDC0C','\uD83E\uDEB2','\uD83D\uDC1E','\uD83E\uDD8F','\uD83D\uDC1F','\uD83E\uDD90','\uD83D\uDD77\uFE0F','\uD83E\uDD82',
      '\uD83D\uDC22','\uD83D\uDC0D','\uD83E\uDD8E','\uD83E\uDD96','\uD83E\uDD95','\uD83D\uDC1D','\uD83D\uDC20','\uD83D\uDC1F',
      '\uD83D\uDC2C','\uD83D\uDC0B','\uD83E\uDD88','\uD83D\uDC18','\uD83D\uDC03','\uD83D\uDC04','\uD83D\uDC0F','\uD83D\uDC11',
      '\uD83D\uDC10','\uD83D\uDC09','\uD83D\uDC15','\uD83D\uDC29','\uD83D\uDC08','\uD83D\uDC13','\uD83E\uDD83','\uD83E\uDD9A',
      '\uD83E\uDD9C','\uD83E\uDDA2','\uD83E\uDDA9','\uD83D\uDD4A\uFE0F','\uD83D\uDC07','\uD83E\uDD9D','\uD83E\uDD9F','\uD83D\uDC3E',
      '\uD83C\uDF35','\uD83C\uDF84','\uD83C\uDF32','\uD83C\uDF33','\uD83C\uDF34','\uD83C\uDF31','\uD83C\uDF3F','\u2618\uFE0F',
      '\uD83C\uDF40','\uD83C\uDF38','\uD83C\uDF39','\uD83C\uDF3B','\uD83C\uDF3A','\uD83C\uDF3C','\uD83C\uDF37','\uD83C\uDF1E',
      '\uD83C\uDF1D','\uD83C\uDF15','\uD83C\uDF0D','\uD83C\uDF0E','\uD83C\uDF0F','\uD83C\uDF0C','\u2B50\uFE0F','\uD83C\uDF1F',
      '\u2728','\u26A1','\uD83D\uDD25','\uD83D\uDCA5','\u2604\uFE0F','\u2600\uFE0F','\u26C5','\u2601\uFE0F',
      '\uD83C\uDF27\uFE0F','\u26C8\uFE0F','\uD83C\uDF29\uFE0F','\u2744\uFE0F','\u26C4','\u2603\uFE0F','\uD83C\uDF08','\u2614\uFE0F',
      '\uD83D\uDCA7','\uD83D\uDCA6','\uD83C\uDF30',
    ],
  },
  {
    key: 'comidas', label: 'Comidas e bebidas', icon: '\uD83C\uDF55',
    emojis: [
      '\uD83C\uDF4F','\uD83C\uDF4E','\uD83C\uDF50','\uD83C\uDF4A','\uD83C\uDF4B','\uD83C\uDF4C','\uD83C\uDF49','\uD83C\uDF47',
      '\uD83C\uDF53','\uD83C\uDF48','\uD83C\uDF52','\uD83C\uDF51','\uD83C\uDF4D','\uD83E\uDD5D','\uD83C\uDF45','\uD83C\uDF46',
      '\uD83E\uDD54','\uD83E\uDD55','\uD83C\uDF3D','\uD83C\uDF36\uFE0F','\uD83E\uDD52','\uD83E\uDD57','\uD83E\uDD6C','\uD83C\uDF44',
      '\uD83C\uDF5E','\uD83E\uDD50','\uD83E\uDD56','\uD83C\uDF56','\uD83C\uDF57','\uD83E\uDD59','\uD83C\uDF54','\uD83C\uDF5F',
      '\uD83C\uDF55','\uD83C\uDF2D','\uD83E\uDD6A','\uD83C\uDF2E','\uD83C\uDF2F','\uD83E\uDD59','\uD83E\uDD63','\uD83C\uDF72',
      '\uD83E\uDD65','\uD83C\uDF5B','\uD83C\uDF63','\uD83C\uDF64','\uD83C\uDF65','\uD83C\uDF66','\uD83C\uDF67','\uD83C\uDF68',
      '\uD83C\uDF69','\uD83C\uDF6A','\uD83C\uDF82','\uD83C\uDF70','\uD83E\uDDC1','\uD83E\uDD67','\uD83C\uDF6B','\uD83C\uDF6C',
      '\uD83C\uDF6D','\uD83C\uDF6E','\uD83C\uDF6F','\uD83E\uDD5B','\u2615','\uD83E\uDE96','\uD83C\uDF75','\uD83E\uDDC3',
      '\uD83E\uDD64','\uD83C\uDF76','\uD83C\uDF7A','\uD83C\uDF7B','\uD83E\uDD42','\uD83C\uDF77','\uD83E\uDD43','\uD83C\uDF78',
      '\uD83C\uDF79','\uD83C\uDF8E','\uD83E\uDD44','\uD83C\uDF7C\uFE0F','\uD83E\uDD61','\uD83E\uDD62',
    ],
  },
  {
    key: 'atividades', label: 'Atividades', icon: '\u26BD',
    emojis: [
      '\u26BD','\uD83C\uDFC0','\uD83C\uDFC8','\u26BE','\uD83E\uDD8E','\uD83C\uDFBE','\uD83C\uDFD0','\uD83C\uDFC9',
      '\uD83E\uDD8F','\uD83C\uDFB1','\uD83E\uDE80','\uD83C\uDFD3','\uD83C\uDFF8','\uD83E\uDD4D','\uD83C\uDFD2','\uD83E\uDD45',
      '\uD83C\uDFD1','\u26F7\uFE0F','\uD83C\uDFC2','\uD83D\uDE4F','\uD83E\uDDD8','\uD83C\uDFCA','\uD83D\uDEB4','\uD83D\uDEB5',
      '\uD83C\uDFC4','\uD83C\uDFC7','\uD83E\uDD3C','\uD83E\uDD3D','\uD83E\uDD3E','\uD83E\uDD38','\uD83C\uDFCB\uFE0F','\uD83E\uDD35',
      '\uD83D\uDEB6','\uD83D\uDCFB','\uD83C\uDFBD','\uD83C\uDFB3','\uD83C\uDFBA','\uD83C\uDFBB','\uD83C\uDFB9','\uD83E\uDD41',
      '\uD83C\uDFB7','\uD83C\uDFB8','\uD83C\uDFBB','\uD83C\uDFB2','\uD83E\uDDF9','\u265F','\uD83C\uDFAF','\uD83C\uDFB3',
      '\uD83C\uDFAC','\uD83C\uDFA4','\uD83C\uDFA7','\uD83C\uDFBC','\uD83C\uDFC6','\uD83E\uDD47','\uD83E\uDD48','\uD83E\uDD49',
      '\uD83C\uDFC5','\uD83C\uDF96\uFE0F','\uD83C\uDF95\uFE0F','\uD83C\uDF97\uFE0F','\uD83C\uDFAB','\uD83C\uDF9F\uFE0F',
      '\uD83C\uDF9E\uFE0F','\uD83C\uDFAD','\uD83E\uDD70','\uD83C\uDFA8','\uD83C\uDFAC','\uD83C\uDFA4','\uD83C\uDFA7',
    ],
  },
  {
    key: 'viagens', label: 'Viagens e lugares', icon: '\uD83D\uDE97',
    emojis: [
      '\uD83D\uDE97','\uD83D\uDE95','\uD83D\uDE99','\uD83D\uDE8C','\uD83D\uDE8E','\uD83C\uDFCE','\uD83D\uDE94','\uD83D\uDE91',
      '\uD83D\uDE92','\uD83D\uDE90','\uD83D\uDE9B','\uD83D\uDE9A','\uD83D\uDE9C','\uD83D\uDE9D','\uD83E\uDDAF','\uD83E\uDDFD',
      '\uD83E\uDDFC','\uD83E\uDDF4','\uD83D\uDEB2','\uD83D\uDEF5','\uD83D\uDE9F','\uD83D\uDEA8','\uD83D\uDE83','\uD83D\uDE8B',
      '\uD83D\uDE9E','\uD83D\uDE84','\uD83D\uDE85','\uD83D\uDE88','\uD83D\uDE82','\uD83D\uDE86','\uD83D\uDE87','\uD83D\uDE8A',
      '\uD83D\uDE89','\u2708\uFE0F','\uD83D\uDEEB','\uD83D\uDEEC','\uD83D\uDEE9\uFE0F','\uD83D\uDCBA','\uD83D\uDEF0\uFE0F',
      '\uD83D\uDE80','\uD83D\uDEF8','\uD83D\uDE81','\uD83D\uDEF6','\u26F5','\uD83D\uDEA3','\uD83D\uDEF4','\uD83D\uDEF3',
      '\u26FD','\uD83D\uDEA7','\uD83D\uDEA6','\uD83D\uDEA5','\uD83D\uDE8F','\uD83D\uDDFA\uFE0F','\uD83D\uDDFF','\uD83D\uDDFD',
      '\uD83D\uDDFC','\uD83C\uDFF0','\uD83C\uDFEF','\uD83C\uDFD1','\uD83C\uDFC1','\uD83C\uDFD0','\uD83C\uDFD2','\u26FA',
      '\uD83C\uDFD5','\uD83C\uDFE0','\uD83C\uDFE1','\uD83C\uDFD8','\uD83C\uDFDA','\uD83C\uDFE2','\uD83C\uDFEC','\uD83C\uDFEA',
      '\uD83C\uDFEB','\uD83C\uDFE3','\uD83C\uDFE4','\uD83C\uDFE5','\uD83C\uDFE6','\uD83C\uDFDB','\u26EA','\uD83D\uDD4C',
      '\uD83D\uDD4D','\uD83D\uDD4B','\uD83D\uDEE5\uFE0F','\u26E9\uFE0F','\uD83C\uDF05','\uD83C\uDF04','\uD83C\uDF20','\uD83C\uDF87',
      '\uD83C\uDF86','\uD83C\uDF07','\uD83C\uDF09','\uD83C\uDF0C','\uD83C\uDF03','\uD83C\uDF0B','\uD83C\uDF91','\uD83C\uDF93',
    ],
  },
  {
    key: 'objetos', label: 'Objetos', icon: '\uD83D\uDCA1',
    emojis: [
      '\u231A','\uD83D\uDCF1','\uD83D\uDCF2','\uD83D\uDCBB','\u2328\uFE0F','\uD83D\uDDA5\uFE0F','\uD83D\uDDA8\uFE0F','\u231B',
      '\u23F3','\u23F0','\u23F1\uFE0F','\u23F2\uFE0F','\uD83D\uDD70\uFE0F','\uD83C\uDF21\uFE0F','\uD83D\uDED2','\uD83D\uDEAC',
      '\u26B0\uFE0F','\uD83E\uDEA6','\u26B1\uFE0F','\uD83D\uDDFF','\uD83E\uDDF8','\uD83E\uDDF5','\uD83E\uDDF6','\uD83D\uDC53',
      '\uD83D\uDC5C','\uD83E\uDD7D','\uD83E\uDD7C','\uD83E\uDDBA','\uD83D\uDC54','\uD83D\uDC55','\uD83D\uDC56','\uD83E\uDDF3',
      '\uD83E\uDD7E','\uD83E\uDD7F','\uD83D\uDC57','\uD83D\uDC58','\uD83E\uDD7B','\uD83E\uDD71','\uD83E\uDD72','\uD83E\uDD73',
      '\uD83D\uDC59','\uD83D\uDC5B','\uD83D\uDC5D','\uD83D\uDEC3','\uD83D\uDEC4','\uD83D\uDEC5','\uD83D\uDC60','\uD83D\uDC61',
      '\uD83D\uDC62','\uD83D\uDC63','\uD83D\uDC64','\uD83D\uDC65','\uD83D\uDC66','\uD83D\uDC67','\uD83D\uDC68','\uD83D\uDC69',
      '\uD83D\uDC6A','\uD83D\uDC6B','\uD83D\uDC6C','\uD83D\uDC6D','\uD83D\uDC6E','\uD83D\uDC6F','\uD83D\uDC70','\uD83D\uDC71',
      '\uD83D\uDC72','\uD83D\uDC73','\uD83D\uDC74','\uD83D\uDC75','\uD83D\uDC76','\uD83D\uDC77','\uD83D\uDC78','\uD83D\uDC79',
      '\uD83D\uDC7A','\uD83D\uDC7B','\uD83D\uDC7C','\uD83D\uDC7D','\uD83D\uDC7E','\uD83D\uDC7F','\uD83D\uDC80','\uD83D\uDC81',
      '\uD83D\uDC82','\uD83D\uDC83','\uD83D\uDC84','\uD83D\uDC85','\uD83D\uDC86','\uD83D\uDC87','\uD83D\uDC88','\uD83D\uDC89',
      '\uD83D\uDC8A','\uD83D\uDC8B','\uD83D\uDC8C','\uD83D\uDC8D','\uD83D\uDC8E','\uD83D\uDC8F','\uD83D\uDC90','\uD83D\uDC91',
      '\uD83D\uDC92','\uD83D\uDC93','\uD83D\uDC94','\uD83D\uDC95','\uD83D\uDC96','\uD83D\uDC97','\uD83D\uDC98','\uD83D\uDC99',
      '\uD83D\uDC9A','\uD83D\uDC9B','\uD83D\uDC9C','\uD83D\uDC9D','\uD83D\uDC9E','\uD83D\uDC9F','\uD83D\uDCA0','\uD83D\uDCA1',
      '\uD83D\uDCA2','\uD83D\uDCA3','\uD83D\uDCA4','\uD83D\uDCA5','\uD83D\uDCA6','\uD83D\uDCA7','\uD83D\uDCA8','\uD83D\uDCA9',
      '\uD83D\uDCAA','\uD83D\uDCAB','\uD83D\uDCAC','\uD83D\uDCAD','\uD83D\uDCAE','\uD83D\uDCAF','\uD83D\uDCB0','\uD83D\uDCB1',
      '\uD83D\uDCB2','\uD83D\uDCB3','\uD83D\uDCB4','\uD83D\uDCB5','\uD83D\uDCB6','\uD83D\uDCB7','\uD83D\uDCB8','\uD83D\uDCB9',
      '\uD83D\uDCBA','\uD83D\uDCBB','\uD83D\uDCBC','\uD83D\uDCBD','\uD83D\uDCBE','\uD83D\uDCBF','\uD83D\uDCC0','\uD83D\uDCC1',
      '\uD83D\uDCC2','\uD83D\uDCC3','\uD83D\uDCC4','\uD83D\uDCC5','\uD83D\uDCC6','\uD83D\uDCC7','\uD83D\uDCC8','\uD83D\uDCC9',
      '\uD83D\uDCCA','\uD83D\uDCCB','\uD83D\uDCCC','\uD83D\uDCCD','\uD83D\uDCCE','\uD83D\uDCCF','\uD83D\uDCD0','\uD83D\uDCD1',
      '\uD83D\uDCD2','\uD83D\uDCD3','\uD83D\uDCD4','\uD83D\uDCD5','\uD83D\uDCD6','\uD83D\uDCD7','\uD83D\uDCD8','\uD83D\uDCD9',
      '\uD83D\uDCDA','\uD83D\uDCDB','\uD83D\uDCDC','\uD83D\uDCDD','\uD83D\uDCDE','\uD83D\uDCDF','\uD83D\uDCE0','\uD83D\uDCE1',
      '\uD83D\uDCE2','\uD83D\uDCE3','\uD83D\uDCE4','\uD83D\uDCE5','\uD83D\uDCE6','\uD83D\uDCE7','\uD83D\uDCE8','\uD83D\uDCE9',
      '\uD83D\uDCEA','\uD83D\uDCEB','\uD83D\uDCEC','\uD83D\uDCED','\uD83D\uDCEE','\uD83D\uDCEF','\uD83D\uDCF0','\uD83D\uDCF1',
      '\uD83D\uDCF2','\uD83D\uDCF3','\uD83D\uDCF4','\uD83D\uDCF5','\uD83D\uDCF6','\uD83D\uDCF7','\uD83D\uDCF8','\uD83D\uDCF9',
      '\uD83D\uDCFA','\uD83D\uDCFB','\uD83D\uDCFC','\uD83D\uDCFD','\uD83D\uDCFE','\uD83D\uDCFF','\uD83D\uDD00','\uD83D\uDD01',
      '\uD83D\uDD02','\uD83D\uDD03','\uD83D\uDD04','\uD83D\uDD05','\uD83D\uDD06','\uD83D\uDD07','\uD83D\uDD08','\uD83D\uDD09',
      '\uD83D\uDD0A','\uD83D\uDD0B','\uD83D\uDD0C','\uD83D\uDD0D','\uD83D\uDD0E','\uD83D\uDD0F','\uD83D\uDD10','\uD83D\uDD11',
      '\uD83D\uDD12','\uD83D\uDD13','\uD83D\uDD14','\uD83D\uDD15','\uD83D\uDD16','\uD83D\uDD17','\uD83D\uDD18','\uD83D\uDD19',
      '\uD83D\uDD1A','\uD83D\uDD1B','\uD83D\uDD1C','\uD83D\uDD1D','\uD83D\uDD1E','\uD83D\uDD1F','\uD83D\uDD20','\uD83D\uDD21',
      '\uD83D\uDD22','\uD83D\uDD23','\uD83D\uDD24','\uD83D\uDD25','\uD83D\uDD26','\uD83D\uDD27','\uD83D\uDD28','\uD83D\uDD29',
      '\uD83D\uDD2A','\uD83D\uDD2B','\uD83D\uDD2C','\uD83D\uDD2D','\uD83D\uDD2E','\uD83D\uDD2F','\uD83D\uDD30','\uD83D\uDD31',
      '\uD83D\uDD32','\uD83D\uDD33','\uD83D\uDD34','\uD83D\uDD35','\uD83D\uDD36','\uD83D\uDD37','\uD83D\uDD38','\uD83D\uDD39',
      '\uD83D\uDD3A','\uD83D\uDD3B','\uD83D\uDD3C','\uD83D\uDD3D','\uD83D\uDD3E','\uD83D\uDD3F','\uD83D\uDD40','\uD83D\uDD41',
      '\uD83D\uDD42','\uD83D\uDD43','\uD83D\uDD44','\uD83D\uDD45','\uD83D\uDD46','\uD83D\uDD47','\uD83D\uDD48','\uD83D\uDD49',
      '\uD83D\uDD4A','\uD83D\uDD4B','\uD83D\uDD4C','\uD83D\uDD4D','\uD83D\uDD4E','\uD83D\uDD4F','\uD83D\uDD50','\uD83D\uDD51',
    ],
  },
  {
    key: 'simbolos', label: 'Símbolos', icon: '\uD83D\uDD23',
    emojis: [
      '\u2764\uFE0F','\uD83E\uDDE1','\uD83E\uDD0E','\uD83E\uDD0D','\uD83E\uDD0C','\uD83E\uDD0A','\uD83D\uDDA4','\uD83E\uDD0B',
      '\uD83E\uDD0F','\u2763\uFE0F','\uD83D\uDC95','\uD83D\uDC9E','\uD83D\uDC93','\uD83D\uDC94','\uD83D\uDC96','\uD83D\uDC97',
      '\uD83D\uDC98','\uD83D\uDC99','\u2695\uFE0F','\u271D\uFE0F','\u262A\uFE0F','\uD83D\uDD49\uFE0F','\u2638\uFE0F','\u2721\uFE0F',
      '\uD83D\uDD4E','\u271A\uFE0F','\u262F\uFE0F','\u2626\uFE0F','\uD83D\uDE90','\u264C','\u2648','\u2649','\u264A',
      '\u264B','\u264C','\u264D','\u264E','\u264F','\u2650','\u2651','\u2652','\u2653','\uD83C\uDD94','\u269B\uFE0F',
      '\uD83C\uDE50','\u2622\uFE0F','\u2623\uFE0F','\uD83D\uDCF4','\uD83D\uDCF3','\uD83C\uDE32','\uD83C\uDE33','\uD83C\uDE34',
      '\uD83C\uDE35','\uD83C\uDE36','\u2734\uFE0F','\uD83C\uDE1A','\uD83C\uDE39','\uD83C\uDE10','\u3299\uFE0F','\u2755',
      '\u2754','\uD83C\uDE2F','\uD83C\uDE30','\uD83C\uDE31','\u274C','\u2B55','\uD83D\uDED1','\u26D4','\uD83D\uDCBC',
      '\uD83D\uDEAB','\uD83D\uDCAF','\uD83D\uDCA2','\u26A0\uFE0F','\u269C\uFE0F','\u269B\uFE0F','\u2622\uFE0F','\u2623\uFE0F',
      '\u2620\uFE0F','\u2755','\u2754','\u2763\uFE0F','\u2764\uFE0F','\u2764\uFE0F\u200D\U0001F525','\u2764\uFE0F\u200D\U0001FA79',
      '\uD83D\uDC94','\uD83D\uDC9B','\uD83D\uDC9A','\uD83D\uDC99','\uD83D\uDC98','\uD83D\uDC97','\uD83D\uDC96','\uD83D\uDC95',
      '\uD83D\uDC94','\uD83D\uDC93','\uD83D\uDC92','\uD83D\uDC91','\uD83D\uDC90','\uD83D\uDC8F','\uD83D\uDC8E','\uD83D\uDC8D',
      '\uD83D\uDC8C','\uD83D\uDC8B','\uD83D\uDC8A','\uD83D\uDC89','\uD83D\uDC88','\uD83D\uDC87','\uD83D\uDC86','\uD83D\uDC85',
      '\uD83D\uDC84','\uD83D\uDC83','\uD83D\uDC82','\uD83D\uDC81','\uD83D\uDC80','\uD83D\uDC7F','\uD83D\uDC7E','\uD83D\uDC7D',
      '\uD83D\uDC7C','\uD83D\uDC7B','\uD83D\uDC7A','\uD83D\uDC79','\uD83D\uDC78','\uD83D\uDC77','\uD83D\uDC76','\uD83D\uDC75',
      '\uD83D\uDC74','\uD83D\uDC73','\uD83D\uDC72','\uD83D\uDC71','\uD83D\uDC70','\uD83D\uDC6F','\uD83D\uDC6E','\uD83D\uDC6D',
      '\uD83D\uDC6C','\uD83D\uDC6B','\uD83D\uDC6A','\uD83D\uDC69','\uD83D\uDC68','\uD83D\uDC67','\uD83D\uDC66','\uD83D\uDC65',
      '\uD83D\uDC64','\uD83D\uDC63','\uD83D\uDC62','\uD83D\uDC61','\uD83D\uDC60','\uD83D\uDC5F','\uD83D\uDC5E','\uD83D\uDC5D',
      '\uD83D\uDC5C','\uD83D\uDC5B','\uD83D\uDC5A','\uD83D\uDC59','\uD83D\uDC58','\uD83D\uDC57','\uD83D\uDC56','\uD83D\uDC55',
      '\uD83D\uDC54','\uD83D\uDC53','\uD83D\uDC52','\uD83D\uDC51','\uD83D\uDC50','\uD83D\uDC4F','\uD83D\uDC4E','\uD83D\uDC4D',
      '\uD83D\uDC4C','\uD83D\uDC4B','\uD83D\uDC4A','\uD83D\uDC49','\uD83D\uDC48','\uD83D\uDC47','\uD83D\uDC46','\uD83D\uDC45',
      '\uD83D\uDC44','\uD83D\uDC43','\uD83D\uDC42','\uD83D\uDC41','\uD83D\uDC40','\uD83D\uDC3F\uFE0F','\uD83D\uDC3E','\uD83D\uDC3D',
      '\uD83D\uDC3C','\uD83D\uDC3B','\uD83D\uDC3A','\uD83D\uDC39','\uD83D\uDC38','\uD83D\uDC37','\uD83D\uDC36','\uD83D\uDC35',
      '\uD83D\uDC34','\uD83D\uDC33','\uD83D\uDC32','\uD83D\uDC31','\uD83D\uDC30','\uD83D\uDC2F','\uD83D\uDC2E','\uD83D\uDC2D',
      '\uD83D\uDC2C','\uD83D\uDC2B','\uD83D\uDC2A','\uD83D\uDC29','\uD83D\uDC28','\uD83D\uDC27','\uD83D\uDC26','\uD83D\uDC25',
      '\uD83D\uDC24','\uD83D\uDC23','\uD83D\uDC22','\uD83D\uDC21','\uD83D\uDC20','\uD83D\uDC1F','\uD83D\uDC1E','\uD83D\uDC1D',
      '\uD83D\uDC1C','\uD83D\uDC1B','\uD83D\uDC1A','\uD83D\uDC19','\uD83D\uDC18','\uD83D\uDC17','\uD83D\uDC16','\uD83D\uDC15',
      '\uD83D\uDC14','\uD83D\uDC13','\uD83D\uDC12','\uD83D\uDC11','\uD83D\uDC10','\uD83D\uDC0F','\uD83D\uDC0E','\uD83D\uDC0D',
      '\uD83D\uDC0C','\uD83D\uDC0B','\uD83D\uDC0A','\uD83D\uDC09','\uD83D\uDC08','\uD83D\uDC07','\uD83D\uDC06','\uD83D\uDC05',
      '\uD83D\uDC04','\uD83D\uDC03','\uD83D\uDC02','\uD83D\uDC01','\uD83D\uDC00','\uD83D\uDC0D','\uD83D\uDC0C','\uD83D\uDC0B',
      '\uD83D\uDC0A','\uD83D\uDC09','\uD83D\uDC08','\uD83D\uDC07','\uD83D\uDC06','\uD83D\uDC05','\uD83D\uDC04','\uD83D\uDC03',
      '\uD83D\uDC02','\uD83D\uDC01','\uD83D\uDC00','\u274C','\u274E','\u2744\uFE0F','\u2745','\u2746','\u2747','\u2748',
      '\u2749','\u274A','\u274B','\u274C','\u274D','\u274E','\u274F','\u2750','\u2751','\u2752','\u2753','\u2754','\u2755',
      '\u2756','\u2757','\u2758','\u2759','\u275A','\u275B','\u275C','\u275D','\u275E','\u275F','\u2760','\u2761','\u2762',
      '\u2763\uFE0F','\u2764\uFE0F','\u2765','\u2766','\u2767','\u2768','\u2769','\u276A','\u276B','\u276C','\u276D','\u276E',
      '\u276F','\u2770','\u2771','\u2772','\u2773','\u2774','\u2775','\u2776','\u2777','\u2778','\u2779','\u277A','\u277B',
      '\u277C','\u277D','\u277E','\u277F','\u2780','\u2781','\u2782','\u2783','\u2784','\u2785','\u2786','\u2787','\u2788',
      '\u2789','\u278A','\u278B','\u278C','\u278D','\u278E','\u278F','\u2790','\u2791','\u2792','\u2793','\u2794','\u2795',
      '\u2796','\u2797','\u2798','\u2799','\u279A','\u279B','\u279C','\u279D','\u279E','\u279F','\u27A0','\u27A1','\u27A2',
      '\u27A3','\u27A4','\u27A5','\u27A6','\u27A7','\u27A8','\u27A9','\u27AA','\u27AB','\u27AC','\u27AD','\u27AE','\u27AF',
      '\u27B0','\u27B1','\u27B2','\u27B3','\u27B4','\u27B5','\u27B6','\u27B7','\u27B8','\u27B9','\u27BA','\u27BB','\u27BC',
      '\u27BD','\u27BE','\u27BF','\u27C0','\u27C1','\u27C2','\u27C3','\u27C4','\u27C5','\u27C6','\u27C7','\u27C8','\u27C9',
      '\u27CA','\u27CB','\u27CC','\u27CD','\u27CE','\u27CF','\u27D0','\u27D1','\u27D2','\u27D3','\u27D4','\u27D5','\u27D6',
      '\u27D7','\u27D8','\u27D9','\u27DA','\u27DB','\u27DC','\u27DD','\u27DE','\u27DF','\u27E0','\u27E1','\u27E2','\u27E3',
      '\u27E4','\u27E5','\u27E6','\u27E7','\u27E8','\u27E9','\u27EA','\u27EB','\u27EC','\u27ED','\u27EE','\u27EF','\u27F0',
      '\u27F1','\u27F2','\u27F3','\u27F4','\u27F5','\u27F6','\u27F7','\u27F8','\u27F9','\u27FA','\u27FB','\u27FC','\u27FD',
      '\u27FE','\u27FF','\u2800','\u2801','\u2802','\u2803','\u2804','\u2805','\u2806','\u2807','\u2808','\u2809','\u280A',
      '\u280B','\u280C','\u280D','\u280E','\u280F','\u2810','\u2811','\u2812','\u2813','\u2814','\u2815','\u2816','\u2817',
      '\u2818','\u2819','\u281A','\u281B','\u281C','\u281D','\u281E','\u281F','\u2820','\u2821','\u2822','\u2823','\u2824',
      '\u2825','\u2826','\u2827','\u2828','\u2829','\u282A','\u282B','\u282C','\u282D','\u282E','\u282F','\u2830','\u2831',
      '\u2832','\u2833','\u2834','\u2835','\u2836','\u2837','\u2838','\u2839','\u283A','\u283B','\u283C','\u283D','\u283E',
      '\u283F','\u2840','\u2841','\u2842','\u2843','\u2844','\u2845','\u2846','\u2847','\u2848','\u2849','\u284A','\u284B',
      '\u284C','\u284D','\u284E','\u284F','\u2850','\u2851','\u2852','\u2853','\u2854','\u2855','\u2856','\u2857','\u2858',
      '\u2859','\u285A','\u285B','\u285C','\u285D','\u285E','\u285F','\u2860','\u2861','\u2862','\u2863','\u2864','\u2865',
      '\u2866','\u2867','\u2868','\u2869','\u286A','\u286B','\u286C','\u286D','\u286E','\u286F','\u2870','\u2871','\u2872',
      '\u2873','\u2874','\u2875','\u2876','\u2877','\u2878','\u2879','\u287A','\u287B','\u287C','\u287D','\u287E','\u287F',
      '\u2880','\u2881','\u2882','\u2883','\u2884','\u2885','\u2886','\u2887','\u2888','\u2889','\u288A','\u288B','\u288C',
      '\u288D','\u288E','\u288F','\u2890','\u2891','\u2892','\u2893','\u2894','\u2895','\u2896','\u2897','\u2898','\u2899',
      '\u289A','\u289B','\u289C','\u289D','\u289E','\u289F','\u28A0','\u28A1','\u28A2','\u28A3','\u28A4','\u28A5','\u28A6',
      '\u28A7','\u28A8','\u28A9','\u28AA','\u28AB','\u28AC','\u28AD','\u28AE','\u28AF','\u28B0','\u28B1','\u28B2','\u28B3',
      '\u28B4','\u28B5','\u28B6','\u28B7','\u28B8','\u28B9','\u28BA','\u28BB','\u28BC','\u28BD','\u28BE','\u28BF','\u28C0',
      '\u28C1','\u28C2','\u28C3','\u28C4','\u28C5','\u28C6','\u28C7','\u28C8','\u28C9','\u28CA','\u28CB','\u28CC','\u28CD',
      '\u28CE','\u28CF','\u28D0','\u28D1','\u28D2','\u28D3','\u28D4','\u28D5','\u28D6','\u28D7','\u28D8','\u28D9','\u28DA',
      '\u28DB','\u28DC','\u28DD','\u28DE','\u28DF','\u28E0','\u28E1','\u28E2','\u28E3','\u28E4','\u28E5','\u28E6','\u28E7',
      '\u28E8','\u28E9','\u28EA','\u28EB','\u28EC','\u28ED','\u28EE','\u28EF','\u28F0','\u28F1','\u28F2','\u28F3','\u28F4',
      '\u28F5','\u28F6','\u28F7','\u28F8','\u28F9','\u28FA','\u28FB','\u28FC','\u28FD','\u28FE','\u28FF',
    ],
  },
  {
    key: 'bandeiras', label: 'Bandeiras', icon: '\uD83C\uDFC1',
    emojis: [
      '\uD83C\uDFF3\uFE0F','\uD83C\uDFF4','\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08','\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F',
      '\uD83C\uDFF4\u200D\u2620\uFE0F','\uD83C\uDFC1','\uD83D\uDEA9','\uD83C\uDF8C','\uD83C\uDFFC','\uD83C\uDFFF',
      '\uD83C\uDDE7\uD83C\uDDF7','\uD83C\uDDFA\uD83C\uDDF8','\uD83C\uDDE7\uD83C\uDDF7','\uD83C\uDDEA\uD83C\uDDF8',
      '\uD83C\uDDE9\uD83C\uDDEA','\uD83C\uDDEA\uD83C\uDDF8','\uD83C\uDDEB\uD83C\uDDF7','\uD83C\uDDEE\uD83C\uDDF9',
      '\uD83C\uDDEF\uD83C\uDDF5','\uD83C\uDDF0\uD83C\uDDF7','\uD83C\uDDF5\uD83C\uDDF9','\uD83C\uDDF7\uD83C\uDDFA',
      '\uD83C\uDDF8\uD83C\uDDF0','\uD83C\uDDF9\uD83C\uDDF7','\uD83C\uDDFA\uD83C\uDDFE','\uD83C\uDDFF\uD83C\uDDF2',
      '\uD83C\uDDF5\uD83C\uDDFF','\uD83C\uDDF3\uD83C\uDDF1','\uD83C\uDDF5\uD83C\uDDED','\uD83C\uDDF5\uD83C\uDDF1',
      '\uD83C\uDDF5\uD83C\uDDF9','\uD83C\uDDF5\uD83C\uDDFC','\uD83C\uDDF5\uD83C\uDDF8','\uD83C\uDDF5\uD83C\uDDF7',
      '\uD83C\uDDF5\uD83C\uDDF6','\uD83C\uDDF5\uD83C\uDDF5','\uD83C\uDDF5\uD83C\uDDF4','\uD83C\uDDF5\uD83C\uDDF3',
      '\uD83C\uDDF5\uD83C\uDDF2','\uD83C\uDDF5\uD83C\uDDF1','\uD83C\uDDF5\uD83C\uDDF0','\uD83C\uDDF4\uD83C\uDDFF',
      '\uD83C\uDDF4\uD83C\uDDF2','\uD83C\uDDF4\uD83C\uDDF1','\uD83C\uDDF4\uD83C\uDDF0','\uD83C\uDDF3\uD83C\uDDFF',
      '\uD83C\uDDF3\uD83C\uDDF5','\uD83C\uDDF3\uD83C\uDDF1','\uD83C\uDDF3\uD83C\uDDF0','\uD83C\uDDF2\uD83C\uDDFF',
      '\uD83C\uDDF2\uD83C\uDDFE','\uD83C\uDDF2\uD83C\uDDFD','\uD83C\uDDF2\uD83C\uDDFC','\uD83C\uDDF2\uD83C\uDDFB',
      '\uD83C\uDDF2\uD83C\uDDFA','\uD83C\uDDF2\uD83C\uDDF9','\uD83C\uDDF2\uD83C\uDDF8','\uD83C\uDDF2\uD83C\uDDF7',
      '\uD83C\uDDF2\uD83C\uDDF6','\uD83C\uDDF2\uD83C\uDDF5','\uD83C\uDDF2\uD83C\uDDF4','\uD83C\uDDF2\uD83C\uDDF3',
      '\uD83C\uDDF2\uD83C\uDDF2','\uD83C\uDDF2\uD83C\uDDF1','\uD83C\uDDF2\uD83C\uDDF0','\uD83C\uDDF1\uD83C\uDDFF',
      '\uD83C\uDDF1\uD83C\uDDFE','\uD83C\uDDF1\uD83C\uDDFD','\uD83C\uDDF1\uD83C\uDDFC','\uD83C\uDDF1\uD83C\uDDFB',
      '\uD83C\uDDF1\uD83C\uDDFA','\uD83C\uDDF1\uD83C\uDDF9','\uD83C\uDDF1\uD83C\uDDF8','\uD83C\uDDF1\uD83C\uDDF7',
      '\uD83C\uDDF1\uD83C\uDDF6','\uD83C\uDDF1\uD83C\uDDF5','\uD83C\uDDF1\uD83C\uDDF4','\uD83C\uDDF1\uD83C\uDDF3',
      '\uD83C\uDDF1\uD83C\uDDF2','\uD83C\uDDF1\uD83C\uDDF1','\uD83C\uDDF1\uD83C\uDDF0','\uD83C\uDDF0\uD83C\uDDFF',
      '\uD83C\uDDF0\uD83C\uDDFE','\uD83C\uDDF0\uD83C\uDDFD','\uD83C\uDDF0\uD83C\uDDFC','\uD83C\uDDF0\uD83C\uDDFB',
      '\uD83C\uDDF0\uD83C\uDDFA','\uD83C\uDDF0\uD83C\uDDF9','\uD83C\uDDF0\uD83C\uDDF8','\uD83C\uDDF0\uD83C\uDDF7',
      '\uD83C\uDDF0\uD83C\uDDF6','\uD83C\uDDF0\uD83C\uDDF5','\uD83C\uDDF0\uD83C\uDDF4','\uD83C\uDDF0\uD83C\uDDF3',
      '\uD83C\uDDF0\uD83C\uDDF2','\uD83C\uDDF0\uD83C\uDDF1','\uD83C\uDDFF\uD83C\uDDFE','\uD83C\uDDFF\uD83C\uDDFC',
      '\uD83C\uDDFF\uD83C\uDDFB','\uD83C\uDDFF\uD83C\uDDFA','\uD83C\uDDFF\uD83C\uDDF9','\uD83C\uDDFF\uD83C\uDDF8',
      '\uD83C\uDDFF\uD83C\uDDF7','\uD83C\uDDFF\uD83C\uDDF6','\uD83C\uDDFF\uD83C\uDDF5','\uD83C\uDDFF\uD83C\uDDF4',
      '\uD83C\uDDFF\uD83C\uDDF3','\uD83C\uDDFF\uD83C\uDDF2','\uD83C\uDDFF\uD83C\uDDF1','\uD83C\uDDFE\uD83C\uDDFF',
      '\uD83C\uDDFE\uD83C\uDDFC','\uD83C\uDDFE\uD83C\uDDFB','\uD83C\uDDFE\uD83C\uDDFA','\uD83C\uDDFE\uD83C\uDDF9',
      '\uD83C\uDDFE\uD83C\uDDF8','\uD83C\uDDFE\uD83C\uDDF7','\uD83C\uDDFE\uD83C\uDDF6','\uD83C\uDDFE\uD83C\uDDF5',
      '\uD83C\uDDFE\uD83C\uDDF4','\uD83C\uDDFE\uD83C\uDDF3','\uD83C\uDDFE\uD83C\uDDF2','\uD83C\uDDFE\uD83C\uDDF1',
      '\uD83C\uDDFD\uD83C\uDDFF','\uD83C\uDDFD\uD83C\uDDFC','\uD83C\uDDFD\uD83C\uDDFB','\uD83C\uDDFD\uD83C\uDDFA',
      '\uD83C\uDDFD\uD83C\uDDF9','\uD83C\uDDFD\uD83C\uDDF8','\uD83C\uDDFD\uD83C\uDDF7','\uD83C\uDDFD\uD83C\uDDF6',
      '\uD83C\uDDFD\uD83C\uDDF5','\uD83C\uDDFD\uD83C\uDDF4','\uD83C\uDDFD\uD83C\uDDF3','\uD83C\uDDFD\uD83C\uDDF2',
      '\uD83C\uDDFD\uD83C\uDDF1','\uD83C\uDDFC\uD83C\uDDFF','\uD83C\uDDFC\uD83C\uDDFE','\uD83C\uDDFC\uD83C\uDDFB',
      '\uD83C\uDDFC\uD83C\uDDFA','\uD83C\uDDFC\uD83C\uDDF9','\uD83C\uDDFC\uD83C\uDDF8','\uD83C\uDDFC\uD83C\uDDF7',
      '\uD83C\uDDFC\uD83C\uDDF6','\uD83C\uDDFC\uD83C\uDDF5','\uD83C\uDDFC\uD83C\uDDF4','\uD83C\uDDFC\uD83C\uDDF3',
      '\uD83C\uDDFC\uD83C\uDDF2','\uD83C\uDDFC\uD83C\uDDF1','\uD83C\uDDFB\uD83C\uDDFF','\uD83C\uDDFB\uD83C\uDDFE',
      '\uD83C\uDDFB\uD83C\uDDFC','\uD83C\uDDFB\uD83C\uDDFA','\uD83C\uDDFB\uD83C\uDDF9','\uD83C\uDDFB\uD83C\uDDF8',
      '\uD83C\uDDFB\uD83C\uDDF7','\uD83C\uDDFB\uD83C\uDDF6','\uD83C\uDDFB\uD83C\uDDF5','\uD83C\uDDFB\uD83C\uDDF4',
      '\uD83C\uDDFB\uD83C\uDDF3','\uD83C\uDDFB\uD83C\uDDF2','\uD83C\uDDFB\uD83C\uDDF1','\uD83C\uDDFA\uD83C\uDDFF',
      '\uD83C\uDDFA\uD83C\uDDFE','\uD83C\uDDFA\uD83C\uDDFC','\uD83C\uDDFA\uD83C\uDDFB','\uD83C\uDDFA\uD83C\uDDF9',
      '\uD83C\uDDFA\uD83C\uDDF8','\uD83C\uDDFA\uD83C\uDDF7','\uD83C\uDDFA\uD83C\uDDF6','\uD83C\uDDFA\uD83C\uDDF5',
      '\uD83C\uDDFA\uD83C\uDDF4','\uD83C\uDDFA\uD83C\uDDF3','\uD83C\uDDFA\uD83C\uDDF2','\uD83C\uDDFA\uD83C\uDDF1',
      '\uD83C\uDDF9\uD83C\uDDFF','\uD83C\uDDF9\uD83C\uDDFE','\uD83C\uDDF9\uD83C\uDDFC','\uD83C\uDDF9\uD83C\uDDFB',
      '\uD83C\uDDF9\uD83C\uDDFA','\uD83C\uDDF9\uD83C\uDDF9','\uD83C\uDDF9\uD83C\uDDF8','\uD83C\uDDF9\uD83C\uDDF7',
      '\uD83C\uDDF9\uD83C\uDDF6','\uD83C\uDDF9\uD83C\uDDF5','\uD83C\uDDF9\uD83C\uDDF4','\uD83C\uDDF9\uD83C\uDDF3',
      '\uD83C\uDDF9\uD83C\uDDF2','\uD83C\uDDF9\uD83C\uDDF1','\uD83C\uDDF8\uD83C\uDDFF','\uD83C\uDDF8\uD83C\uDDFE',
      '\uD83C\uDDF8\uD83C\uDDFC','\uD83C\uDDF8\uD83C\uDDFB','\uD83C\uDDF8\uD83C\uDDFA','\uD83C\uDDF8\uD83C\uDDF9',
      '\uD83C\uDDF8\uD83C\uDDF8','\uD83C\uDDF8\uD83C\uDDF7','\uD83C\uDDF8\uD83C\uDDF6','\uD83C\uDDF8\uD83C\uDDF5',
      '\uD83C\uDDF8\uD83C\uDDF4','\uD83C\uDDF8\uD83C\uDDF3','\uD83C\uDDF8\uD83C\uDDF2','\uD83C\uDDF8\uD83C\uDDF1',
      '\uD83C\uDDF7\uD83C\uDDFF','\uD83C\uDDF7\uD83C\uDDFE','\uD83C\uDDF7\uD83C\uDDFC','\uD83C\uDDF7\uD83C\uDDFB',
      '\uD83C\uDDF7\uD83C\uDDFA','\uD83C\uDDF7\uD83C\uDDF9','\uD83C\uDDF7\uD83C\uDDF8','\uD83C\uDDF7\uD83C\uDDF7',
      '\uD83C\uDDF7\uD83C\uDDF6','\uD83C\uDDF7\uD83C\uDDF5','\uD83C\uDDF7\uD83C\uDDF4','\uD83C\uDDF7\uD83C\uDDF3',
      '\uD83C\uDDF7\uD83C\uDDF2','\uD83C\uDDF7\uD83C\uDDF1','\uD83C\uDDF6\uD83C\uDDFF','\uD83C\uDDF6\uD83C\uDDFE',
      '\uD83C\uDDF6\uD83C\uDDFC','\uD83C\uDDF6\uD83C\uDDFB','\uD83C\uDDF6\uD83C\uDDFA','\uD83C\uDDF6\uD83C\uDDF9',
      '\uD83C\uDDF6\uD83C\uDDF8','\uD83C\uDDF6\uD83C\uDDF7','\uD83C\uDDF6\uD83C\uDDF6','\uD83C\uDDF6\uD83C\uDDF5',
      '\uD83C\uDDF6\uD83C\uDDF4','\uD83C\uDDF6\uD83C\uDDF3','\uD83C\uDDF6\uD83C\uDDF2','\uD83C\uDDF6\uD83C\uDDF1',
      '\uD83C\uDDF5\uD83C\uDDFF','\uD83C\uDDF5\uD83C\uDDFE','\uD83C\uDDF5\uD83C\uDDFC','\uD83C\uDDF5\uD83C\uDDFB',
      '\uD83C\uDDF5\uD83C\uDDFA','\uD83C\uDDF5\uD83C\uDDF9','\uD83C\uDDF5\uD83C\uDDF8','\uD83C\uDDF5\uD83C\uDDF7',
      '\uD83C\uDDF5\uD83C\uDDF6','\uD83C\uDDF5\uD83C\uDDF5','\uD83C\uDDF5\uD83C\uDDF4','\uD83C\uDDF5\uD83C\uDDF3',
      '\uD83C\uDDF5\uD83C\uDDF2','\uD83C\uDDF5\uD83C\uDDF1','\uD83C\uDDF4\uD83C\uDDFF','\uD83C\uDDF4\uD83C\uDDFE',
      '\uD83C\uDDF4\uD83C\uDDFC','\uD83C\uDDF4\uD83C\uDDFB','\uD83C\uDDF4\uD83C\uDDFA','\uD83C\uDDF4\uD83C\uDDF9',
      '\uD83C\uDDF4\uD83C\uDDF8','\uD83C\uDDF4\uD83C\uDDF7','\uD83C\uDDF4\uD83C\uDDF6','\uD83C\uDDF4\uD83C\uDDF5',
      '\uD83C\uDDF4\uD83C\uDDF4','\uD83C\uDDF4\uD83C\uDDF3','\uD83C\uDDF4\uD83C\uDDF2','\uD83C\uDDF4\uD83C\uDDF1',
      '\uD83C\uDDF3\uD83C\uDDFF','\uD83C\uDDF3\uD83C\uDDFE','\uD83C\uDDF3\uD83C\uDDFC','\uD83C\uDDF3\uD83C\uDDFB',
      '\uD83C\uDDF3\uD83C\uDDFA','\uD83C\uDDF3\uD83C\uDDF9','\uD83C\uDDF3\uD83C\uDDF8','\uD83C\uDDF3\uD83C\uDDF7',
      '\uD83C\uDDF3\uD83C\uDDF6','\uD83C\uDDF3\uD83C\uDDF5','\uD83C\uDDF3\uD83C\uDDF4','\uD83C\uDDF3\uD83C\uDDF3',
      '\uD83C\uDDF3\uD83C\uDDF2','\uD83C\uDDF3\uD83C\uDDF1','\uD83C\uDDF2\uD83C\uDDFF','\uD83C\uDDF2\uD83C\uDDFE',
      '\uD83C\uDDF2\uD83C\uDDFC','\uD83C\uDDF2\uD83C\uDDFB','\uD83C\uDDF2\uD83C\uDDFA','\uD83C\uDDF2\uD83C\uDDF9',
      '\uD83C\uDDF2\uD83C\uDDF8','\uD83C\uDDF2\uD83C\uDDF7','\uD83C\uDDF2\uD83C\uDDF6','\uD83C\uDDF2\uD83C\uDDF5',
      '\uD83C\uDDF2\uD83C\uDDF4','\uD83C\uDDF2\uD83C\uDDF3','\uD83C\uDDF2\uD83C\uDDF2','\uD83C\uDDF2\uD83C\uDDF1',
      '\uD83C\uDDF1\uD83C\uDDFF','\uD83C\uDDF1\uD83C\uDDFE','\uD83C\uDDF1\uD83C\uDDFC','\uD83C\uDDF1\uD83C\uDDFB',
      '\uD83C\uDDF1\uD83C\uDDFA','\uD83C\uDDF1\uD83C\uDDF9','\uD83C\uDDF1\uD83C\uDDF8','\uD83C\uDDF1\uD83C\uDDF7',
      '\uD83C\uDDF1\uD83C\uDDF6','\uD83C\uDDF1\uD83C\uDDF5','\uD83C\uDDF1\uD83C\uDDF4','\uD83C\uDDF1\uD83C\uDDF3',
      '\uD83C\uDDF1\uD83C\uDDF2','\uD83C\uDDF1\uD83C\uDDF1','\uD83C\uDDF0\uD83C\uDDFF','\uD83C\uDDF0\uD83C\uDDFE',
      '\uD83C\uDDF0\uD83C\uDDFC','\uD83C\uDDF0\uD83C\uDDFB','\uD83C\uDDF0\uD83C\uDDFA','\uD83C\uDDF0\uD83C\uDDF9',
      '\uD83C\uDDF0\uD83C\uDDF8','\uD83C\uDDF0\uD83C\uDDF7','\uD83C\uDDF0\uD83C\uDDF6','\uD83C\uDDF0\uD83C\uDDF5',
      '\uD83C\uDDF0\uD83C\uDDF4','\uD83C\uDDF0\uD83C\uDDF3','\uD83C\uDDF0\uD83C\uDDF2','\uD83C\uDDF0\uD83C\uDDF1',
    ],
  },
]

const QUICK_REACTIONS = ['\uD83D\uDC4D', '\u2764\uFE0F', '\uD83D\uDE02', '\uD83C\uDF89', '\uD83D\uDD25', '\uD83D\uDC40', '\uD83D\uDE4F', '\uD83D\uDC4E', '\uD83D\uDE80']

// Keyword map for emoji search in Portuguese. Keys are emoji codepoints,
// values are space-separated lowercase keywords.
const EMOJI_KEYWORDS: Record<string, string> = {
  '\u2764\uFE0F': 'coracao heart amor love',
  '\uD83D\uDC4D': 'joinha like thumbsup ok positivo',
  '\uD83D\uDC4E': 'negativo thumbsdown dislike',
  '\uD83D\uDD25': 'fogo fire flame chama',
  '\uD83D\uDC40': 'olhos eyes olhar',
  '\uD83D\uDE00': 'sorriso smile feliz',
  '\uD83D\uDE01': 'feliz happy sorriso',
  '\uD83D\uDE05': 'suor riso nervous',
  '\uD83D\uDE02': 'rir laugh lol',
  '\uD83D\uDE18': 'beijo kiss amor',
  '\uD83D\uDE0D': 'apaixonado love heart olhos',
  '\uD83E\uDD29': 'coracao olhos star struck',
  '\uD83D\uDE22': 'triste cry chorar',
  '\uD83D\uDE2D': 'chorar cry triste',
  '\uD83D\uDE21': 'raiva angry bravo',
  '\uD83D\uDE20': 'raiva angry bravo',
  '\uD83D\uDE08': 'diabo devil evil',
  '\uD83D\uDCA9': 'cocô poop merda',
  '\uD83D\uDC7E': 'monstro alien monster',
  '\uD83E\uDD21': 'palhaco clown palhaço',
  '\uD83D\uDC4C': 'ok joinha perfeito',
  '\u270C\uFE0F': 'vitoria peace v paz',
  '\uD83D\uDC4F': 'aplaudir clap palmas',
  '\uD83D\uDCAA': 'forca muscle forca musculo',
  '\uD83D\uDC31': 'gato cat',
  '\uD83D\uDC36': 'cachorro dog',
  '\uD83D\uDC3B': 'urso bear panda',
  '\uD83E\uDD81': 'leao lion leão',
  '\uD83D\uDC3C': 'panda',
  '\uD83D\uDC28': 'koala',
  '\uD83D\uDC2F': 'tigre tiger',
  '\uD83D\uDC3E': 'pata paw',
  '\uD83D\uDC18': 'elefante elephant',
  '\uD83D\uDC14': 'galinha chicken',
  '\uD83D\uDC0D': 'cobra snake',
  '\uD83D\uDC22': 'tartaruga turtle',
  '\uD83D\uDC1F': 'peixe fish',
  '\uD83D\uDC20': 'tropical peixe fish',
  '\uD83D\uDC2C': 'golfinho dolphin',
  '\uD83D\uDC07': 'coelho rabbit',
  '\uD83D\uDC0C': 'rato mouse',
  '\uD83C\uDF38': 'tulipa flower flor',
  '\uD83C\uDF39': 'rosa flower flor',
  '\uD83C\uDF3A': 'flor hibisco',
  '\uD83C\uDF37': 'flor tulipa',
  '\uD83C\uDF1E': 'sol sun',
  '\uD83C\uDF1D': 'sol sun',
  '\uD83C\uDF1F': 'estrela star brilho',
  '\u2B50\uFE0F': 'estrela star',
  '\u2728': 'brilho sparkle estrela',
  '\u2600\uFE0F': 'sol sun',
  '\u2601\uFE0F': 'nuvem cloud',
  '\u26C5': 'nuvem sol cloud',
  '\u2744\uFE0F': 'neve snowflake floco',
  '\u26C4': 'boneco neve snowman',
  '\uD83C\uDF55': 'pizza',
  '\uD83C\uDF54': 'hamburguer burger',
  '\uD83C\uDF5F': 'batata fries',
  '\uD83C\uDF2D': 'pipoca popcorn',
  '\uD83C\uDF6A': 'cookie biscoito',
  '\uD83C\uDF82': 'halloween abobora',
  '\uD83C\uDF70': 'bolo cake aniversario',
  '\uD83C\uDF6B': 'chocolate',
  '\u2615': 'cafe coffee',
  '\uD83C\uDF75': 'cha tea',
  '\uD83C\uDF77': 'vinho wine',
  '\uD83C\uDF7A': 'cerveja beer',
  '\uD83C\uDF7B': 'copo drink',
  '\u26BD': 'futebol soccer ball',
  '\uD83C\uDFC0': 'basquete basketball',
  '\uD83C\uDFC8': 'futebol americano football',
  '\u26BE': 'baseball beisebol',
  '\uD83C\uDFBE': 'tennis tenis',
  '\uD83C\uDFB1': 'bilhar pool',
  '\uD83C\uDFAF': 'dardo alvo target',
  '\uD83C\uDFAC': 'clapperboard filme cinema',
  '\uD83C\uDFA4': 'microfone palco',
  '\uD83C\uDFA7': 'fones headphone musica',
  '\uD83C\uDFC6': 'trofeu trophy vitoria',
  '\uD83E\uDD47': 'medalha ouro gold',
  '\uD83E\uDD48': 'medalha prata silver',
  '\uD83E\uDD49': 'medalha bronze',
  '\uD83D\uDE97': 'carro car',
  '\uD83D\uDE95': 'taxi taxi',
  '\uD83D\uDE99': 'onibus bus',
  '\uD83D\uDE8C': 'carro race',
  '\uD83D\uDE8E': 'moto motorcycle',
  '\uD83D\uDEB2': 'bicicleta bike',
  '\u2708\uFE0F': 'aviao plane',
  '\uD83D\uDE80': 'foguete rocket',
  '\uD83D\uDEF0\uFE0F': 'skate',
  '\u26F5': 'vela barco sailboat',
  '\uD83D\uDEA3': 'barco boat',
  '\u26FD': 'gasolina gas bomba',
  '\uD83C\uDFE0': 'casa house home',
  '\uD83C\uDFE1': 'casa garden',
  '\uD83C\uDFE2': 'predio office',
  '\uD83C\uDFEB': 'cafe shop',
  '\uD83C\uDFE5': 'restaurante',
  '\uD83C\uDFE6': 'loja shop',
  '\u26EA': 'igreja church',
  '\uD83C\uDFEF': 'castelo castle',
  '\uD83C\uDFE3': 'amor hotel love',
  '\uD83D\uDCF1': 'celular phone mobile',
  '\u2328\uFE0F': 'teclado keyboard',
  '\uD83D\uDDA5\uFE0F': 'mouse computador',
  '\u23F0': 'relogio alarme',
  '\u23F1\uFE0F': 'cronometro stopwatch',
  '\u231A': 'relogio watch',
  '\uD83D\uDD70\uFE0F': 'ampulheta hourglass',
  '\uD83D\uDCA1': 'lampada idea ideia',
  '\uD83D\uDDA8\uFE0F': 'pincel paint',
  '\uD83D\uDCBC': 'pasta briefcase',
  '\uD83D\uDCB0': 'dinheiro money',
  '\uD83D\uDCB2': 'moeda coin',
  '\uD83D\uDCB5': 'cartao card',
  '\uD83D\uDD11': 'chave key',
  '\uD83D\uDD10': 'cadeado lock lock2',
  '\uD83D\uDD12': 'cadeado lock',
  '\uD83D\uDCD5': 'livro book',
  '\uD83D\uDCD6': 'livro book',
  '\uD83D\uDCD7': 'livro verde',
  '\uD83D\uDCD8': 'livro open',
  '\uD83D\uDCD3': 'livro etiqueta',
  '\uD83D\uDCD2': 'livro indice',
  '\uD83D\uDCDA': 'livros library',
  '\uD83D\uDCD1': 'favorito bookmark',
  '\uD83D\uDCDD': 'escrever write pen',
  '\u270F\uFE0F': 'lapis pencil escrever',
  '\uD83D\uDCBE': 'disco disk save',
  '\uD83D\uDCBF': 'disco cd',
  '\uD83D\uDCBB': 'computador computer pc',
  '\uD83C\uDFAE': 'gameplay joystick videogame',
  '\uD83D\uDD79\uFE0F': 'joystick game',
  '\uD83C\uDFF0': 'castelo castle',
  '\uD83C\uDF88': 'balao balloon',
  '\uD83C\uDF86': 'balao festa',
  '\uD83C\uDF87': 'balao',
  '\uD83C\uDF89': 'festa party',
  '\uD83C\uDF8E': 'confete',
  '\uD83C\uDF91': 'balao lantern',
  '\uD83C\uDF93': 'formatura graduation',
  '\uD83C\uDF96\uFE0F': 'medalha militar',
  '\uD83C\uDF95\uFE0F': 'tenis racket',
  '\uD83C\uDF97\uFE0F': 'volley volei',
  '\uD83C\uDFAB': 'ticket ingresso',
  '\uD83C\uDF9F\uFE0F': 'ticket admission',
  '\uD83C\uDF9E\uFE0F': 'ticket',
  '\uD83C\uDFAD': 'mascara mask',
  '\uD83C\uDFA8': 'arte palette',
  '\uD83D\uDCFA': 'dvd',
  '\uD83D\uDCFB': 'som audio',
  '\uD83C\uDFB5': 'musica note',
  '\uD83C\uDFB6': 'musica notes',
  '\uD83C\uDFB9': 'piano',
  '\uD83C\uDFBA': 'saxophone',
  '\uD83C\uDFBB': 'trompete trumpet',
  '\uD83C\uDFB7': 'flauta',
  '\uD83C\uDFB8': 'guitarra guitar',
  '\uD83C\uDFB2': 'bateria drum',
  '\uD83E\uDD41': 'tambor drum',
  '\uD83E\uDD4D': 'bola ball',
  '\uD83C\uDFD1': 'circus circo',
  '\uD83C\uDFD2': 'bicycle',
  '\uD83C\uDFD3': 'bola magic',
  '\uD83C\uDFC1': ' bandeira flag',
  '\uD83C\uDFC4': 'surf',
  '\uD83C\uDFC7': 'cavalo horse',
  '\uD83E\uDD3C': 'surf',
  '\uD83E\uDD3D': 'handstand',
  '\uD83E\uDD3E': 'wrestling',
  '\uD83E\uDD38': 'gymnastics',
  '\uD83C\uDFCB\uFE0F': 'golf',
  '\uD83E\uDD35': 'golf',
  '\uD83D\uDEB6': 'corrida run',
  '\uD83D\uDEB4': 'bike',
  '\uD83D\uDEB5': 'mountain bike',
  '\u26F7\uFE0F': 'ski',
  '\uD83C\uDFC2': 'snowboard',
  '\uD83C\uDFCA': 'surf',
  '\uD83E\uDDD8': 'yoga',
  '\uD83D\uDE4F': 'pray',
  '\uD83D\uDC51': 'coroa crown',
  '\uD83D\uDC52': 'chapeu hat',
  '\uD83D\uDC53': 'oculos glasses',
  '\uD83D\uDC54': 'oculos',
  '\uD83D\uDC55': 'camiseta shirt',
  '\uD83D\uDC56': 'jeans',
  '\uD83D\uDC57': 'vestido dress',
  '\uD83D\uDC58': 'kimono',
  '\uD83D\uDC59': 'biquini bikini',
  '\uD83D\uDC5B': 'vestido',
  '\uD83D\uDC5C': 'sapatos shoes',
  '\uD83D\uDC5F': 'tenis sneakers',
  '\uD83D\uDC60': 'salto heels',
  '\uD83D\uDC61': 'sandália',
  '\uD83D\uDC62': 'bota boots',
  '\uD83D\uDC84': 'batom lipstick',
  '\uD83D\uDC85': 'pintura nails',
  '\uD83D\uDC86': 'corte hair',
  '\uD83D\uDC87': 'barbear',
  '\uD83E\uDDF3': 'mascara',
  '\uD83E\uDDF4': 'sabao soap',
  '\uD83E\uDDF5': 'esponja',
  '\uD83E\uDDF6': 'escova',
  '\uD83E\uDDF8': 'pincel',
  '\uD83E\uDDF9': 'ferramenta tool',
  '\uD83E\uDDFA': 'esponja',
  '\uD83E\uDDFB': 'toalha towel',
  '\uD83E\uDDFC': 'papel',
  '\uD83E\uDDFD': 'boneco',
  '\uD83E\uDDFF': 'mascara',
  '\uD83E\uDD8C': 'drink',
  '\uD83E\uDD8D': 'saude',
  '\uD83E\uDD8E': 'jogo',
  '\uD83E\uDD8F': 'carta',
  '\uD83E\uDD90': 'crustaceo',
  '\uD83E\uDD91': 'caranguejo',
  '\uD83E\uDD92': 'lagosta',
  '\uD83E\uDD93': 'macaco',
  '\uD83E\uDD94': 'tucano',
  '\uD83E\uDD95': 'sauro',
  '\uD83E\uDD96': 'veado',
  '\uD83E\uDD97': 'urso',
  '\uD83E\uDD98': 'panda',
  '\uD83E\uDD99': 'veado',
  '\uD83E\uDD9A': 'guaxinim',
  '\uD83E\uDD9C': 'leao',
  '\uD83E\uDD9D': 'doninha',
  '\uD83E\uDD9F': 'veado',
  '\uD83E\uDDA2': 'castor',
  '\uD83E\uDDA9': 'panda',
  '\uD83E\uDE80': 'balanca',
  '\uD83E\uDE96': 'copo',
  '\uD83E\uDEB0': 'inseto',
  '\uD83E\uDEB2': 'larva',
}

const RECENT_STORAGE_KEY = 'atlas_recent_emojis'
const MAX_RECENT = 32

function loadRecent(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch { return [] }
}

function saveRecent(list: string[]) {
  try { localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(list.slice(0, MAX_RECENT))) } catch {}
}

function addRecent(emoji: string) {
  const list = loadRecent().filter((e) => e !== emoji)
  list.unshift(emoji)
  saveRecent(list)
  return list
}

export function EmojiPicker({ onSelect, onClose, quickOnly = false, x = undefined, y = undefined }: { onSelect: (emoji: string) => void; onClose?: () => void; quickOnly?: boolean; x?: number; y?: number }) {
  const [recentEmojis, setRecentEmojis] = useState(loadRecent)
  const [search, setSearch] = useState('')
  const [category, setCategory] = useState('recentes')
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose?.()
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [onClose])

  const handleSelect = useCallback((emoji: string) => {
    setRecentEmojis(addRecent(emoji))
    onSelect(emoji)
  }, [onSelect])

  const allEmojiList = useMemo(() => EMOJI_CATEGORIES.flatMap(c => c.emojis), [])

  const searchResults = useMemo(() => {
    if (!search.trim()) return null
    const q = search.toLowerCase()
    return allEmojiList.filter(e => {
      // Match by typing the emoji itself
      if (e.includes(q)) return true
      // Match by keyword (Portuguese names)
      const kw = EMOJI_KEYWORDS[e]
      return kw && kw.includes(q)
    })
  }, [search, allEmojiList])

  const displayEmojis = useMemo(() => {
    if (search.trim()) return searchResults || []
    if (category === 'recentes') return recentEmojis.length ? recentEmojis : EMOJI_CATEGORIES.find(c => c.key === 'smileys')!.emojis
    return EMOJI_CATEGORIES.find(c => c.key === category)?.emojis || []
  }, [search, category, searchResults, recentEmojis])

  const sectionTitle = useMemo(() => {
    if (search.trim()) return 'Resultados da busca'
    if (category === 'recentes') return recentEmojis.length ? 'Recentes' : 'Smileys e pessoas'
    return EMOJI_CATEGORIES.find(c => c.key === category)?.label || ''
  }, [search, category, recentEmojis])

  let posStyle: CSSProperties | undefined
  if (x != null && y != null) {
    const PW = quickOnly ? 300 : 340
    const PH = quickOnly ? 48 : 420
    let left = x, top = y
    if (left + PW / 2 > window.innerWidth - 8) left = window.innerWidth - PW / 2 - 8
    if (left - PW / 2 < 8) left = PW / 2 + 8
    const openBelow = top - PH - 8 < 8
    posStyle = {
      position: 'fixed', left,
      top: openBelow ? top + 20 : top,
      bottom: 'auto', right: 'auto', margin: 0,
      transform: openBelow ? 'translate(-50%, 0)' : 'translate(-50%, -100%) translateY(-8px)',
    }
  }

  if (quickOnly) {
    return (
      <div className="emoji-quick-bar" ref={ref} style={posStyle}>
        {QUICK_REACTIONS.map(emoji => (
          <button key={emoji} className="emoji-quick-btn" onClick={() => onSelect(emoji)}>{emoji}</button>
        ))}
        <button className="emoji-quick-more" onClick={() => onSelect('open-picker')}>
          <span style={{ fontSize: 14 }}>...</span>
        </button>
      </div>
    )
  }

  return (
    <div className="emoji-picker" ref={ref} style={posStyle}>
      <div className="emoji-picker-topbar">
        {EMOJI_CATEGORIES.map(cat => (
          <button
            key={cat.key}
            className={`emoji-picker-cat-icon ${category === cat.key ? 'active' : ''}`}
            onClick={() => { setCategory(cat.key); setSearch('') }}
            title={cat.label}
          >
            {cat.icon}
          </button>
        ))}
      </div>
      <div className="emoji-picker-search">
        <SearchIcon size={16} />
        <input
          type="text"
          placeholder="Pesquisar emoji"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="emoji-picker-content">
        <div className="emoji-picker-section-title">
          {category === 'recentes' && !recentEmojis.length && !search.trim() ? (
            <span className="emoji-picker-empty-recent">
              <ClockIcon size={16} /> Nenhum emoji recente
            </span>
          ) : sectionTitle}
        </div>
        <div className="emoji-picker-grid">
          {displayEmojis.map((emoji, i) => (
            <button
              key={emoji + i}
              className="emoji-picker-item"
              onClick={() => handleSelect(emoji)}
            >
              {emoji}
            </button>
          ))}
          {displayEmojis.length === 0 && search.trim() && (
            <div className="emoji-picker-no-results">Nenhum emoji encontrado</div>
          )}
        </div>
      </div>
    </div>
  )
}

export { QUICK_REACTIONS }
